<!-- READONLY MODE -->
<div *ngIf="isDisabled; else editMode" class="signature-readonly">
  <ng-container *ngIf="firstName || lastName || signatureDataUrl; else emptyReadonly">
    <div class="signature-person" *ngIf="firstName || lastName">
      {{ firstName }} {{ lastName }}
    </div>
    <img *ngIf="signatureDataUrl"
         class="signature-preview"
         [src]="signatureDataUrl"
         alt="Unterschrift"/>
    <div class="signature-underline"></div>
  </ng-container>
  <ng-template #emptyReadonly>
    <span class="signature-empty">Keine Unterschrift</span>
  </ng-template>
</div>

<!-- EDIT MODE -->
<ng-template #editMode>
  <div class="signature-edit">
    <div class="signature-names">
      <input nbInput
             class="name-input"
             type="text"
             placeholder="Vorname"
             [value]="firstName"
             (input)="onFirstNameChange($any($event.target).value)" />
      <input nbInput
             class="name-input"
             type="text"
             placeholder="Nachname"
             [value]="lastName"
             (input)="onLastNameChange($any($event.target).value)" />
    </div>

    <div class="canvas-wrapper">
      <canvas #signatureCanvas
              class="signature-canvas"
              width="400"
              height="120">
      </canvas>
      <div class="canvas-hint" *ngIf="!hasSignature">Hier unterschreiben</div>
    </div>

    <div class="canvas-actions">
      <button nbButton ghost status="danger" size="small" type="button"
              [disabled]="!hasSignature"
              (click)="clearSignature()">
        <nb-icon icon="trash-2-outline" pack="eva"></nb-icon>
        Unterschrift löschen
      </button>
    </div>
  </div>
</ng-template>
